import React, { forwardRef } from 'react';
import styled from 'styled-components';
import Grid from '@ntuctech/devex-tangram/Grid';
import { SvgCalendar } from '@ntuctech/devex-tangram/Icon';
import DatePicker from 'react-datepicker';
import { Typography } from '@ntuctech/devex-tangram';
import { SCREEN_SIZE } from '../../../lib/mediaQuery';

export const WhiteBox = styled.div`
  background-color: #fff;
  padding: 2rem;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  border: 1px solid #eaeaea;

  .no-spacing {
    padding: 0 !important;
    margin: 0 !important;
  }
  ${SCREEN_SIZE.Only.Tablet} {
    padding: 1.5rem !important;
  }
  ${SCREEN_SIZE.Below.MobileL} {
    padding: 1rem !important;
    border-radius: 0;
    border: 0;
  }
`;

export const RmvInnerPad = styled.div`
  padding: 0;
  margin: 0;
  .no-margin {
    > p {
      margin: 0;
    }
  }
  .margin-bottom-24 {
    margin-bottom: 1.5rem !important;
  }
`;

const StyledTypography = styled(Typography)`
  font-size: 0.75rem;
  color: #666666;
  font-weight: 700;
  margin-top: 1.5rem;
`;

const AddMarginSticky = styled.div`
  @media screen and (max-width: 600px) {
    margin-bottom: 20px;
  }
`;

const DatePickerInput = styled.div`
  position: relative;
  width: 200px;
  > div:hover input {
    border-color: #666666 !important;
  }
  > div:hover label {
    color: inherit !important;
  }
  > div input:hover {
    border-color: #1454b8 !important;
  }
  > div {
    margin-bottom: 0;
    width: 100%;
    margin-top: 15px;
  }
  p {
    color: inherit;
    width: 200px;
    height: 3rem;
    outline: 0;
    border-radius: 0.25rem;
    border: 0.0625rem solid #666666;
    padding: 0.75rem;
    padding-bottom: calc(0.75rem + 0.0625rem);
    will-change: box-shadow;
    -webkit-transition: box-shadow 0.3s;
    transition: box-shadow 0.3s;
    padding-top: 0.87rem;
  }
  div {
    position: absolute;
    top: 12.85px;
    margin: 0 auto 0 0;
    width: 22px;
    right: 23px;
    cursor: pointer;
  }
`;

const VoucherFooterSection = (props) => {
  const { voucherData, setVoucherData, isB2bEnabled } = props;

  /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <DatePickerInput className="no-margin">
      <p ref={ref}>{value}</p>
      <div>
        <SvgCalendar size="m" color="#1557BF" onClick={onClick} data-testid="calendericon" />
      </div>
    </DatePickerInput>
  ));

  return (
    !isB2bEnabled && (
      <AddMarginSticky>
        <WhiteBox isB2bUser={isB2bEnabled}>
          <RmvInnerPad>
            <Grid container className="no-spacing">
              <Grid item xs={12} className="no-spacing">
                <Typography variant="titleS" data-testid="voucher-date">
                  Send voucher on
                </Typography>
                <StyledTypography>Select your preferred date</StyledTypography>
                <DatePicker
                  placeholderText="Select your preferred date"
                  name="VoucherDate"
                  selected={voucherData.metadata.deliveryTime}
                  dateFormat="eee dd MMM yyyy"
                  minDate={new Date()}
                  onChange={(date) => {
                    setVoucherData({
                      ...voucherData,
                      metadata: {
                        ...voucherData.metadata,
                        deliveryTime: date,
                      },
                    });
                  }}
                  showPopperArrow={false}
                  customInput={<ExampleCustomInput />}
                />
              </Grid>
            </Grid>
          </RmvInnerPad>
        </WhiteBox>
      </AddMarginSticky>
    )
  );
};

export default VoucherFooterSection;
